module.exports = __webpack_public_path__ + "img/Folded_Paper_logo.90099b0e.svg";